import * as React from 'react';
import {FunctionComponent} from 'react';
import {GraphReportRow} from '../Models/ReportTemplate';
import {UserWithSnippets} from './Internal/UserWithSnippets';
import {Graph} from '../Components/Graph';
import {
    graphValueForField,
    graphValueToFormattedValue,
    ReportField,
    reportFieldToLabel,
} from '../../Models/ReportField';

interface OwnProps {
    template: GraphReportRow;
    usersWithSnippets: UserWithSnippets[];
    numDataColumns: number;
    highlightedSnippetIds: number[];
}

export const TemplateGraph: FunctionComponent<OwnProps> = ({template, usersWithSnippets, numDataColumns, highlightedSnippetIds}) => {
    return (
        <tr>
            {usersWithSnippets.map((publicUser) => {
                const values = (pU: UserWithSnippets): Array<{x: number; y: number}> => {
                    return pU.snippets
                        .map((snippet) => ({
                            x: graphValueForField(template.x, snippet),
                            y: graphValueForField(template.y, snippet),
                        }))
                        .filter((v) => v.y !== undefined) as Array<{
                        x: number;
                        y: number;
                    }>;
                };

                const highlightCoordinates = publicUser.snippets
                    .filter((snippet) => highlightedSnippetIds.includes(snippet.id))
                    .map((snippet) => ({
                        x: graphValueForField(template.x, snippet),
                        y: graphValueForField(template.y, snippet),
                    }))
                    .filter((coord) => coord.x !== undefined && coord.y !== undefined) as Array<{ x: number; y: number }>;

                return (
                    <td colSpan={numDataColumns} className="border-end border-2">
                        <span className="progresstable__title">
                            {reportFieldToLabel(template.y)} vs. {reportFieldToLabel(template.x)}
                        </span>
                        <Graph
                            showTrend={template.x === ReportField.ExecutedAt}
                            values={values(publicUser)}
                            domainValues={usersWithSnippets.flatMap(values)}
                            formatX={(x) => graphValueToFormattedValue(template.x, x as number)}
                            formatY={(y) => graphValueToFormattedValue(template.y, y as number)}
                            highlights={highlightCoordinates.length > 0 ? highlightCoordinates : undefined}
                        />
                    </td>
                );
            })}
        </tr>
    );
};
